module.exports = __webpack_public_path__ + "static/img/m4-2.37e8ccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/sky101/m4-2.png
// module id = O/J3
// module chunks = 1